import React, { Component } from 'react'
import { connect } from 'react-redux'
import IconSVG from 'svg-inline-react'
import classnames from 'classnames'
import { MenuItem as AmbMenuItem } from 'react-aria-menubutton'
import { endUserCount } from 'app/modules/org/selectors'

import style from './style'

const LabelClasses = classnames(style.AudienceOption_Label, 'flex')

export const EveryoneString = 'Everyone'
export const VisitorString = 'Site Visitors'
export const UserString = 'Known Users'

export const Audience = {
  VISITORS: {
    display: VisitorString
  },
  USERS: {
    display: UserString
  },
  EVERYONE: {
    display: EveryoneString,
    renderDisplay(userCount) {
      const noun = userCount > 1 ? 'Users' : 'User'
      return `${ EveryoneString } (${ VisitorString }, ${ userCount } ${ noun })`
    }
  }
}

const AnonymousUserLabel = (
  <div className={ LabelClasses }>
    <IconSVG
      src={ require('!svg-inline?removeTags=true!images/svg/question-stamp.svg') }
      element="div"
      className="icon"
      style={{ width: 11, height: 11 }}
    />
    {"any site visitors who aren't logged in and"}
  </div>
)

class IdentifiedUsersOptionInner extends Component {
  render() {
    const { endUsersCount } = this.props
    return (
      <AmbMenuItem
        key="USERS"
        value="USERS"
        text="known users"
        className={ style.AudienceOption }
      >
        <div className="dsg-Body">{ Audience.USERS.display }</div>
        <div className={ LabelClasses }>
          <IconSVG
            src={ require('!svg-inline?removeTags=true!images/icons/user-icon.svg') }
            element="div"
            className="icon"
            style={{ width: 11, height: 13 }} />
          {endUsersCount ? `${ endUsersCount } users` : '' }
        </div>
      </AmbMenuItem>
    )
  }
}

export const IdentifiedUsersOption = connect(mapStateToProps)(IdentifiedUsersOptionInner)

class EveryoneOptionInner extends Component {
  render () {
    const { endUsersCount } = this.props
    const labels = (
      <div className="flex">
        { AnonymousUserLabel }
        <div className={ LabelClasses }>
          <IconSVG
            src={ require('!svg-inline?removeTags=true!images/icons/user-icon.svg') }
            element="div"
            className="icon"
            style={{ marginLeft: '.2rem', width: 11, height: 13 }} />
          {endUsersCount ? `${ endUsersCount } users` : '' }
        </div>
      </div>
    )

    return (
      <AmbMenuItem
        key="EVERYONE"
        value="EVERYONE"
        text="everyone"
        className={ style.AudienceOption }
      >
        <div className="dsg-Body">{ Audience.EVERYONE.display }</div>
        { labels }
      </AmbMenuItem>
    )
  }
}

const mapStateToProps = state => ({
  endUsersCount: endUserCount(state)
})

export const EveryoneOption = connect(mapStateToProps)(EveryoneOptionInner)

export const AnonymousOption = (
  <AmbMenuItem
    key="VISITORS"
    value="VISITORS"
    text="site visitors"
    className={`${style.AudienceOption} nm-anonymous-option`}
  >
    <div className="dsg-Body">{ Audience.VISITORS.display }</div>
    { AnonymousUserLabel }
  </AmbMenuItem>
)



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/AudienceOption/index.js